<template>
    <div>

        <rkm-area
            type="fieldset"
            title="Filtros"
        >

            <rkm-form
                ref="Form"
            >

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :max-date="data.form.dataAtual"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="agendamentoExame"
                            label="Exame"
                            show-default-option
                            text-field="nome"
                            v-model="model.exameId"
                            value-field="id"
                            default-option-text="Todos"
                            @change="handleExame()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :searchFields="localPaciente.autocompleteFieldsPaciente.paciente"
                            :repository="repositories.paciente"
                            v-model="paciente"
                            :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                            label="Paciente"
                            uppercase
                            @select="handlePaciente()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-checkbox-group
                            label="Status"
                            v-model="model.statusId"
                            :options="model.status"
                            :validations="validations.status"
                            text-field="nome"
                            value-field="id"
                            buttons
                            button-color="outline-primary"
                            @change="handlePaciente()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeSolicitante"
                            label="Unidade solicitante"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="unidadeId"
                            @change="setListagem()"
                            default-option-text="Todas"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="infraestruturas"
                            textField="nome"
                            v-model="model.infraestruturaId"
                            valueField="id"
                            show-default-option
                            @change="setListagem()"
                            default-option-text="Todos"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="showList"
            no-margin-top
            title="Resultado"
        >

            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                    :disabled="itemsNotSave.length === 0"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>
                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>
                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>
                <rkm-button
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                    :disabled="itemsNotSave.length === 0"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itemsNotSave.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>
        </rkm-area>

        <template>

                <rkm-table
                    v-if="showList"
                    :items="itemsNotSave"
                    :fields="fields"
                    hide-filters
                    sort-by="pacienteNome"
                    :sort-compare="sortCompare"
                    hide-pagination
                    class="table-agendamento"
                >

                    <template v-slot:cell(dataAgendamento)="{ item }">
                        {{ item.dataAgendamento.split("-").reverse().join("/") }}
                    </template>

                    <template v-slot:cell(pacienteNome)="{ item }">
                        {{ item.pacienteNome }}

                        <template v-if="item.pacientePreferenciaNome">
                            <strong>({{ item.pacienteNomeSocial }})</strong>
                        </template>
                    </template>

                    <template v-slot:custom-foot>
                        <tr>
                            <td class="table-td" :colspan="selectedCols.length + 3"></td>
                            <td class="table-td text-center">
                                Total
                            </td>
                            <td class="table-td text-center">
                                {{ total }}
                            </td>
                        </tr>
                    </template>
                </rkm-table>
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, file } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Filters.
import format from '@/filters/formats'

export default {
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                status: { required: true },
            }
        },
        infraestruturas() {

            this.setInfraestrutura()

            if (this.model.unidadeId && this.unidadeSolicitante.length > 0) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.handleInfraestrutura(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('exameLaboratorial.relatorioHistoricoPaciente'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
            exportacao: this.getConectaSusRepository('exportacao.exameLaboratorial'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                unidadeId: null,
                infraestruturaId: null,
                pacienteId: null,
                exameId: null,
                exameNome: null,
                status: [],
                statusId: [],
                statusSelecionado: [],
                periodo: {
                    start: null,
                    end: null,
                },
            },
            paciente: null,
            agendamentoExame: [],
            unidadeSolicitante: [],
            itemsNotSave: [],
            total: null,
            showList: false,
            enums: {
                statusAgendamento,
                preferenciaNome
            },
            localPaciente: {
                autocompleteFieldsPaciente: {
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            },
            indeterminate: false,
            filterDefault: {},
            selectedAll: false,
            columns: [
                { key: 'pacienteNome', label: 'Paciente', sortable: true, fixed: true },
                { key: 'pacienteNascimento', label: 'Data de nascimento', class: 'col-min text-center', sortable: true, fixed: true },
                { key: 'exameNome', label: 'Exame', sortable: true, fixed: true },
                { key: 'procedimento', label: 'Procedimento', sortable: true },
                { key: 'unidade', label: 'Unidade solicitante', sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                { key: 'status', label: 'Status', class: 'col-min text-center', sortable: true, fixed: true },
                { key: 'quantidade', label: 'Quantidade', class: 'col-min text-center', sortable: true, fixed: true },
            ],
            selectedCols: [],
        }
    },
    mixins: [repository, error, object, formats, data, file, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'dataAgendamento') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {

            this.model.periodo = this.data.form.periodo

            this.setStatus()
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioHistoricoPaciente(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioHistoricoPaciente(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            if (this.paciente) {

                data.pacienteId = this.paciente.id
                data.pacienteNome = this.paciente.cidadao.nome
            }

            if (this.model.exameId) {

                data.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (this.model.unidadeId) {

                data.unidadeNome = this.data.form.unidades.find(u => u.id == data.unidadeId).nomeFantasia
            }

            if (data.infraestruturaId) {

                data.infraestruturaNome = this.infraestruturas.find(u => u.id == data.infraestruturaId).nome
            }

            data.statusId.forEach(status => {

                const selecionado = data.status.find(u => u.id == status)

                if (status) {

                    data.statusSelecionado.push({

                        id: selecionado.id,
                        nome: selecionado.nome,
                    })
                }
            })

            this.formateDates(data.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        search() {

            this.setLoading()

            this.repositories.exame.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                    this.total = data.model.total
                    this.showList = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exameId = null
            this.paciente = null
            this.model.pacienteId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.itemsNotSave = null

            this.setStatus()
            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setStatus() {

            this.model.statusId = [
                this.enums.statusAgendamento.AGENDADO,
                this.enums.statusAgendamento.REALIZADO,
                this.enums.statusAgendamento.FALTOU,
                this.enums.statusAgendamento.PENDENTE_ASSINATURA,
            ]

            this.model.status = [
                {
                    "id": this.enums.statusAgendamento.AGENDADO,
                    "nome": "AGENDADO",
                },
                {
                    "id": this.enums.statusAgendamento.REALIZADO,
                    "nome": "COLETA REALIZADA",
                },
                {
                    "id": this.enums.statusAgendamento.FALTOU,
                    "nome": "FALTOU",
                },
                {
                    "id": this.enums.statusAgendamento.PENDENTE_ASSINATURA,
                    "nome": "RESULTADO LANÇADO",
                },
            ]
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        setListagem() {

            this.itemsNotSave = null
            this.showList = false
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleInfraestrutura(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {

                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {

                this.model.infraestruturaId = null
            }
        },
        setInfraestrutura() {

            this.model.infraestruturaId = null
        },
        loadFields() {

            this.setLoading()
            this.setListagem()

            this.repositories.exame.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadUnidadeSolicitante(data.model.unidades, null)
                    this.loadExame(data.model.exames)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeSolicitante(agendamento) {

            const unidades = []

            agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.unidadeId).infraestruturas.find(u => u.id
                        === infraestrutura.infraestruturaId).principal

                const unidadeInserida = unidades.find(u => u.unidadeId
                    === infraestrutura.unidadeId)

                if (unidadeInserida) {

                    let verifyUnidade = unidadeInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.infraestruturaId)

                    if (!verifyUnidade) {

                        unidadeInserida.infraestruturas.push({

                            id: infraestrutura.infraestruturaId,
                            nome: infraestrutura.infraestruturaNome,
                            principal: principal,
                        })
                    }

                } else {

                    unidades.push({

                        unidadeId: infraestrutura.unidadeId,
                        nomeFantasia: infraestrutura.unidadeNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.infraestruturaId,
                                nome: infraestrutura.infraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeSolicitante = unidades
        },
        loadExame(exames) {

            const exameCadastrado = []

            exames.map(exame => {
                exameCadastrado.push({

                    id: exame.id,
                    nome: exame.nome,
                })
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado
        },
        handlePeriodo() {

            this.model.exameId = null
            this.paciente = null
            this.model.pacienteId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null

            this.loadFields()
        },
        handleExame() {

            this.paciente = null
            this.model.pacienteId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null

            this.loadFields()
        },
        handlePaciente() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null

            this.loadFields()
        },
    },
    filters: {
        ...format,
    },
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
        'model.periodo.start'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.periodo.end'() {

           if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'paciente'() {

            this.handlePaciente()
        },
    }
}
</script>

<style scoped>
.table-th {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-agendamento >>> .col-width {
    width: 16%;
}
</style>